import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../index';
import { storageResetAction } from '../storeReset';
import { ReferenceDto } from '@api/models/employees/ReferenceDto';
import { TrainingVersionDto } from '@api/models/training/TrainingVersionDto';
import { LanguageDto } from '@api/models/settings/LanguageDto';

interface TrainingRunState {
  persons: ReferenceDto[];
  versions: TrainingVersionDto[];
  languages: LanguageDto[];
  selectedLang: string;
}

const initialState: TrainingRunState = {
  persons: [],
  versions: [],
  languages: [],
  selectedLang: '',
};

export const trainingRunSlice = createSlice({
  name: 'trainingRun',
  initialState,
  reducers: {
    setPersons: (state, action: PayloadAction<ReferenceDto[]>) => {
      state.persons = action.payload;
    },
    setVersions: (state, action: PayloadAction<TrainingVersionDto[]>) => {
      state.versions = action.payload;
    },
    removeVersion: (state, action: PayloadAction<string>) => {
      state.versions = state.versions.filter((v) => v.id !== action.payload);
    },
    setLanguages: (state, action: PayloadAction<LanguageDto[]>) => {
      state.languages = action.payload;
    },
    setSelectedLang: (state, action: PayloadAction<string>) => {
      state.selectedLang = action.payload;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(storageResetAction, () => initialState);
  },
});

export const trainingRunActions = trainingRunSlice.actions;
export const selectTrainingRunPersons = (state: RootState) => state.trainingRun.persons;
export const selectTrainingRunVersions = (state: RootState) => state.trainingRun.versions;
export const selectTrainingRunLanguages = (state: RootState) => state.trainingRun.languages;
export const selectTrainingRunSelectedLang = (state: RootState) => state.trainingRun.selectedLang;